import Backgrounds from '@/components/ToolPopovers/Background';

import { cloneDeep } from 'lodash';

import { getBackgroundType } from '@/common/utils';

import {
  usePopoverCreationTool,
  useDigitalBackgroundMenu,
  useBackgroundGetter,
  useAppCommon
} from '@/hooks';
import { PER_PAGE_10 } from '@/common/constants';

export default {
  components: {
    Backgrounds
  },
  setup() {
    const { setToolNameSelected } = usePopoverCreationTool();

    const {
      currentThemeId,
      toggleModal,
      getBackgroundTypeData,
      getBackgroundData,
      getBackgroundCategories
    } = useDigitalBackgroundMenu();
    const { setNotification } = useAppCommon();

    const { backgrounds: appliedBackground } = useBackgroundGetter();

    return {
      setToolNameSelected,
      currentThemeId,
      toggleModal,
      getBackgroundTypeData,
      getBackgroundData,
      appliedBackground,
      setNotification,
      getBackgroundCategories
    };
  },
  data() {
    return {
      backgroundTypes: {},
      backgrounds: [],
      noBackgroundLength: 4,
      selectedType: { sub: {} },
      isProduction: process.env.VUE_APP_PRODUCTION,
      isLoadingCategory: true,
      perPages: PER_PAGE_10,
      currentPage: 1
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    /**
     * Init data when loaded
     */
    async initData() {
      this.backgroundTypes = await this.getBackgroundTypeData();
      // Update for PP-2407
      if (this.isProduction) {
        this.selectedType = {
          value: this.backgroundTypes.CATEGORY.id,
          sub: this.backgroundTypes.CATEGORY.value[0].id
        };
      } else {
        this.selectedType = getBackgroundType(
          {}, //this.appliedBackground,
          this.backgroundTypes,
          this.currentThemeId
        );
      }
      if (!this.selectedType.sub) {
        this.selectedType.sub = this.backgroundTypes.THEME.value[0].id;
        const notification = {
          isShow: true,
          type: 'warning',
          title: 'Warning',
          text: 'Please select a theme for this book'
        };
        this.setNotification({ notification });
      }

      this.getBackgrounds();
    },
    /**
     * Get background data from API
     */
    async getBackgrounds() {
      this.backgrounds = await this.getBackgroundData(
        this.selectedType.value,
        this.selectedType.sub,
        null // it's needed
      );
    },
    /**
     * Event fire when choose background type
     *
     * @param {Object}  data  data of chosen background type
     */
    onChangeType(data) {
      this.selectedType = data;

      this.getBackgrounds();
    },
    /**
     * Trigger hooks to set tool name is empty and then close popover when click Cancel button
     */
    onClose() {
      this.setToolNameSelected('');
    },
    /**
     * Trigger mutation to set Background
     *
     * @param {Object}  background  selected background
     */
    onApplyBackground(background) {
      this.$root.$emit('digitalAddBackground', {
        background: {
          ...cloneDeep(background),
          opacity: 1
        },
        isLeft: true
      });

      this.onClose();
    },
    async onLoadMoreCategory() {
      if (this.currentPage > 0) {
        this.currentPage++;
        const bgCategories = await this.getBackgroundCategories(
          this.currentPage,
          true
        );
        if (bgCategories.length < this.perPages) {
          this.isLoadingCategory = false;
          this.currentPage = -1;
        }
        this.backgroundTypes.CATEGORY.value = [
          ...this.backgroundTypes.CATEGORY.value,
          ...bgCategories
        ];
        this.backgroundTypes.CATEGORY.value.sort((item1, item2) =>
          item1.name.localeCompare(item2.name)
        );
      }
    }
  }
};
